// Mock data for Greenwood Property Group website

export const companyInfo = {
  name: "Greenwood Property Group",
  tagline: "Your Trusted Partner in Property Services & Real Estate",
  serviceArea: "Specializing in Upper Cape and the Mid Cape Area",
  phone: "508-360-2370",
  email: "contactus@greenwoodpropertygroup.com",
  logo: "https://customer-assets.emergentagent.com/job_gifted-beaver-1/artifacts/026zb0h5_4E7EAB49-508C-4056-BA30-BED3B8F97853_1_201_a.jpeg"
};

export const socialLinks = {
  propertyGroup: {
    facebook: "https://www.facebook.com/greenwoodpropertygroup",
    instagram: "https://www.instagram.com/greenwoodpropertygroupllc"
  },
  realEstate: {
    facebook: "https://www.facebook.com/profile.php?id=61579873897696",
    instagram: "https://www.instagram.com/cc_realtorsean",
    website: "https://SeanGreenwood.chrealtygroup.com"
  },
  tiling: {
    facebook: "https://www.facebook.com/profile.php?id=100091266620716",
    instagram: "https://www.instagram.com/top_notch_tile_"
  }
};

export const propertyServices = [
  {
    id: 1,
    title: "Property Management",
    description: "Comprehensive property management services including tenant screening, rent collection, maintenance coordination, and property inspections.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Professional Painting",
    description: "Interior and exterior painting services with attention to detail, quality materials, and timely completion for residential and commercial properties.",
    icon: "Paintbrush"
  },
  {
    id: 3,
    title: "Expert Tiling Services",
    description: "Professional tile installation for kitchens, bathrooms, and floors. Quality craftsmanship with a variety of styles and materials.",
    icon: "Grid3x3"
  },
  {
    id: 4,
    title: "Lawn Care Services",
    description: "Complete lawn maintenance including mowing, trimming, fertilization, and seasonal cleanup to keep your property looking pristine.",
    icon: "Leaf"
  },
  {
    id: 5,
    title: "House Cleaning",
    description: "Thorough residential and commercial cleaning services. Regular maintenance or deep cleaning to meet your specific needs.",
    icon: "Sparkles"
  },
  {
    id: 6,
    title: "General Maintenance",
    description: "All-around property maintenance and repairs. From minor fixes to major projects, we keep your property in top condition.",
    icon: "Wrench"
  }
];

export const realEstateServices = [
  {
    id: 1,
    title: "Buy Your Dream Home",
    description: "Expert guidance through the home buying process. We'll help you find the perfect property that fits your needs and budget.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Sell Your Property",
    description: "Maximize your property value with our professional listing services, marketing expertise, and negotiation skills.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Rental Management",
    description: "Full-service rental property management including tenant placement, rent collection, maintenance, and financial reporting.",
    icon: "Key"
  }
];

export const realtorInfo = {
  name: "Sean Greenwood",
  title: "Licensed Realtor",
  photo: "https://customer-assets.emergentagent.com/job_gifted-beaver-1/artifacts/urhc4p21_IMG_1642.jpeg"
};

export const cabinRentals = {
  title: "Greenwood Hill Cabin Rentals",
  description: "Experience the perfect getaway in our beautiful mountain cabins. Fully equipped, peaceful settings, and unforgettable memories await.",
  link: "https://greenwoodhillcabinrentals.com",
  logo: "https://customer-assets.emergentagent.com/job_gifted-beaver-1/artifacts/cja85jtl_IMG_8262.png",
  features: [
    "Fully Equipped Cabins",
    "Stunning Mountain Views",
    "Pet-Friendly Options",
    "Year-Round Availability"
  ]
};
